var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.1 39",
    style: {
      enableBackground: "new 0 0 39.1 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#007B7B;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-4",
    transform: "translate(14.291 15.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "st0",
    d: "M15.8-1.3c-0.2-1-1-1.7-1.9-2c-1.7-0.4-8.6-0.4-8.6-0.4s-6.9,0-8.6,0.5c-1,0.3-1.7,1-1.9,2 C-5.6,0.5-5.7,2.2-5.7,4c0,1.8,0.1,3.6,0.5,5.3c0.3,0.9,1,1.7,1.9,1.9c1.7,0.5,8.6,0.5,8.6,0.5s6.9,0,8.6-0.5c1-0.3,1.7-1,1.9-2 c0.3-1.7,0.5-3.5,0.5-5.3C16.3,2.2,16.1,0.4,15.8-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "st0",
    d: "M3,7.3L8.8,4L3,0.8V7.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.e01f5aecc1c99b5c0d9e705794df6d02.svg";
export { ForwardRef as ReactComponent };